import React from "react";
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import {
  cilBell,
  cilCreditCard,
  cilCommentSquare,
  cilEnvelopeOpen,
  cilFile,
  cilSettings,
  cilTask,
  cilUser,
  cilAccountLogout,
  cilPencil,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { Link, useNavigate } from "react-router-dom";
import avatar8 from "../../../assets/images/avatars/10.jpg";

const AppHeaderDropdown = ({ srcImg, name }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/admin/login");
  };

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-center" className="py-0" caret={true}>
        <CAvatar src={srcImg || avatar8} size="md" />
        <span className="text-dark text-capitalize ms-sm-2 headerdropdown">
          {name || "Test"}
        </span>
      </CDropdownToggle>

      {/* <CAvatar src="" size="md" /> */}
      <CDropdownMenu className="pt-0 pb-0">
        {/* <CDropdownHeader className="bg-light fw-semibold py-2">
          Account
        </CDropdownHeader> */}
        {/* <CDropdownItem href="#">
          <CIcon icon={cilBell} className="me-2" />
          Updates
          <CBadge color="info" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilEnvelopeOpen} className="me-2" />
          Messages
          <CBadge color="success" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilTask} className="me-2" />
          Tasks
          <CBadge color="danger" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCommentSquare} className="me-2" />
          Comments
          <CBadge color="warning" className="ms-2">
            42
          </CBadge>
        </CDropdownItem> */}
        {/* <CDropdownHeader className="bg-light fw-semibold py-2">
          Settings
        </CDropdownHeader> */}
        {/* <CDropdownItem href="#">
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem> */}
        {/* <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCreditCard} className="me-2" />
          Payments
          <CBadge color="secondary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilFile} className="me-2" />
          Projects
          <CBadge color="primary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem> */}
        {/* <CDropdownItem href="#"> */}
        <div>
          <Link
            // to="/admin/admin-edit"
            className="nav-view-link-custom dropdown-item"
          >
            <CIcon icon={cilPencil} className="me-2" />
            Edit Profile
          </Link>
          {/* <CBadge color="primary" className="ms-2">
            42
          </CBadge> */}
          {/* </CDropdownItem> */}
          {/* <CDropdownDivider className="m-0" /> */}
          <CDropdownItem onClick={handleLogout} href="#">
            <CIcon icon={cilAccountLogout} className="me-2" />
            Sign Out
          </CDropdownItem>
        </div>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
